import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'

//TODO hacer staggerChildren de li

const List = styled(motion.ul)`
    margin: .5rem 0;
    border-top: 1px solid black;
    border-bottom: 1px solid black;
    padding: 1rem 0;

    @media all and (max-width: 650px) {
        padding: .5rem 0;
    }
`

const Item = styled(motion.li)`
    font-size: 1rem;

    @media all and (max-width: 650px) {
        font-size: .8rem;
    }
`

const Details = ({selected}) => {
    return(
        <List>
            <Item>Prenda: {
                    selected.producto
                }
            </Item>
            <Item>Técnica: {
                    selected.tecnica === 'sublimado' ? 'Sublimado' :
                    selected.tecnica === 'estampado' ? 'Estampado' :
                    selected.tecnica === 'bordado' && 'Bordado'
                }
            </Item>
            <Item>Tamaño del logo: {
                    selected.size === "big" ? 'Grande' : 'Chico'
                }
            </Item>
            <Item>Ubicación del logo: {
                    selected.ubicacion === 'frente' ? 'Frente' :
                    selected.ubicacion === 'dorso' ? 'Dorso':
                    selected.ubicacion === 'ambos' && 'Frente y Dorso'
                }
            </Item>
            <Item>Color de la prenda: {
                    selected.color === 'blanco' ? 'Blanco':
                    selected.color === 'negro' ? 'Negro':
                    selected.color === 'azul-marino' ? 'Azul Marino':
                    selected.color === 'azul-francia' ? 'Azul Francia':
                    selected.color === 'verde-benetton' ? 'Verde Benetton':
                    selected.color === 'rojo' ? 'Rojo':
                    selected.color === 'gris' && 'Gris'
                }
            </Item>
            <Item>Cantidad: {
                    selected.cantidad === "A" ? '10 - 20' : 
                    selected.cantidad === "B" ? '21 - 50' :
                    selected.cantidad === "C" ? '51 - 100' :
                    selected.cantidad === "D" && '101 - 200'
                }
            </Item>
        </List>
    )
}

export default Details